import axios from "../../../axios"
import { paramsObjToGraphQLParams } from "@/utils/index.js"

export default {
  fetch(queryData) {
    return axios.post('', {
      query: `
        query {
          newsletterSubscribers ${paramsObjToGraphQLParams(queryData)} {
            order_by,
            pagination_page,
            pagination_limit,
            total_pages,
            items {
              id,
              mailchimp_id,
              phone_number,
              email,
              first_name,
              last_name,
              created_at,
              updated_at
            }
          }
        }
      `
    })
  },
  add(subscriber) {
    return axios.post('', {
      query: `
        mutation {
          createNewsletterSubscriber ${paramsObjToGraphQLParams(subscriber)} {
            id,
            mailchimp_id,
            phone_number,
            email,
            first_name,
            last_name,
            created_at,
            updated_at
          }
        }
      `
    })
  },
  update(subscriber) {
    return axios.post('', {
      query: `
        mutation {
          updateNewsletterSubscriber ${paramsObjToGraphQLParams(subscriber)} {
            id,
            mailchimp_id,
            phone_number,
            email,
            first_name,
            last_name,
            created_at,
            updated_at
          }
        }
      `
    })
  },
  delete(subscriberId) {
    return axios.post('', {
      query: `
        mutation {
          deleteNewsletterSubscriber (
            id: ${subscriberId}
          )
        }
      `
    })
  },
  infos(subscriberId) {
    return axios.post('', {
      query: `
        query {
          newsletterSubscriberInfos (
            id: ${subscriberId}
          ) {
            id,
            mailchimp_id,
            phone_number,
            email,
            first_name,
            last_name,
            created_at,
            updated_at
          }
        }
      `
    })
  }
}
